<template>
  <div class="clickStatistics-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-date-picker v-model="time" type="date" placeholder="请选择日期" size="small" @change="changeTime"></el-date-picker>
    </div>
    <!--表格数据-->
    <el-table max-height="650" :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <!--
      <el-table-column prop="date" label="日期" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.date | changeDate}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="aid" label="广告ID" align="center"></el-table-column>
      <el-table-column prop="yesterdayCount" label="昨日" align="center"></el-table-column>
      <el-table-column prop="todayCount" label="今日" align="center"></el-table-column>
      <el-table-column prop="weekCount" label="本周" align="center"></el-table-column>
      <el-table-column prop="monthCount" label="本月" align="center"></el-table-column>
      <el-table-column prop="totalCount" label="总" align="center"></el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 10, 15, 20]" :current-page="form.pageNumber" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total" v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import API from '@/api'
import {changeTime} from '@/utils/global'

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      time: '',
      // 广告点击请求列表参数
      form: {
        pageNumber: 1,
        pageSize: 20,
        start: '',
        end: '',
      }
    }
  },
  created() {
    this.getClickStatistics()
  },
  methods: {
    getTag(value, i) {
      this.index = i;
    },
    // 请求广告列表数据
    getClickStatistics(type) {
      this.loading = true
      if (type === 'status') {
        this.from.pageNumber = 1
      }
      API.getClickStatistics(this.form).then(res => {
        if (res.code === 200 && res.data.logs) {
          this.tableData = res.data.logs
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.form.pageSize = size
      this.getClickStatistics()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.form.pageNumber = number
      this.getClickStatistics()
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.form.sumDate = changeTime(time)
      } else {
        this.form.sumDate = ''
      }
      this.getClickStatistics()
    },
  }
}
</script>
<style scoped lang="scss">
</style>
